import { isAdmin } from './userRole';

function memberUserId(member) {
  return Number(member?.user_id ?? member?.id);
}

function memberRole(member) {
  return String(member?.role || '').trim().toLowerCase();
}

function memberStatus(member) {
  return String(member?.status || 'accepted').trim().toLowerCase();
}

/** True when this user is a group admin/owner (or the group creator). */
export function isGroupAdmin(user, members = [], groupCreatedBy = null) {
  if (!user?.id) return false;
  if (groupCreatedBy != null && Number(groupCreatedBy) === Number(user.id)) {
    return true;
  }
  if (!Array.isArray(members)) return false;
  return members.some((member) => {
    if (memberUserId(member) !== Number(user.id)) return false;
    const status = memberStatus(member);
    if (status && !['accepted', 'approved'].includes(status)) return false;
    return ['admin', 'owner'].includes(memberRole(member));
  });
}

export function canEditGroupPost(user, post) {
  if (!user?.id || !post) return false;
  if (Number(user.id) === Number(post.user_id)) return true;
  return isAdmin(user);
}

/** True when this user can deactivate or delete the group (owner, group admin, or site admin). */
export function canManageGroup(user, members = [], groupCreatedBy = null) {
  if (!user?.id) return false;
  if (isAdmin(user)) return true;
  return isGroupAdmin(user, members, groupCreatedBy);
}

export function isGroupPendingDelete(group) {
  return Boolean(group?.pending_delete || group?.scheduled_delete_at);
}

export function isGroupDeactivated(group) {
  if (isGroupPendingDelete(group)) return true;
  if (group?.is_deactivated) return true;
  return group?.is_active === 0 || group?.is_active === '0' || group?.is_active === false;
}

export function formatGroupDeleteAt(value) {
  if (!value) return '';
  const raw = String(value).trim();
  const iso = raw.includes('T') ? raw : raw.replace(' ', 'T');
  const date = new Date(iso.includes('+') || iso.endsWith('Z') ? iso : `${iso}+08:00`);
  if (Number.isNaN(date.getTime())) return raw;
  return date.toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}

export function canDeleteGroupPost(user, post, members = [], groupCreatedBy = null) {
  if (!user?.id || !post) return false;
  if (Number(user.id) === Number(post.user_id)) return true;
  if (isAdmin(user)) return true;
  return isGroupAdmin(user, members, groupCreatedBy);
}

export function canDeleteGroupReply(user, reply, members = [], groupCreatedBy = null) {
  if (!user?.id || !reply) return false;
  if (Number(user.id) === Number(reply.user_id)) return true;
  if (isAdmin(user)) return true;
  return isGroupAdmin(user, members, groupCreatedBy);
}
